<template>
  <FormModal :name="name" header="Request Invite">
    <FormModalBody
      :is-button-loading="form.processing"
      @submit="sendRequestInvite"
    >
      <div class="tw-space-y-2">
        <FormRadioGroup
          v-model="form.groupMembers.message"
          :options="options"
          button-classes="tw-w-full"
        >
          <template #label>Do you live in this city or just visiting?</template>
          <template #default="{ option }">
            {{ option.label }}
          </template>
        </FormRadioGroup>
      </div>
    </FormModalBody>
  </FormModal>
</template>

<script setup>
import FormModalBody from '@/shared/components/modals/FormModal/FormModalBody.vue'
import FormRadioGroup from '@/shared/components/forms/FormRadioGroup.vue'
import FormModal from '@/shared/components/modals/FormModal/FormModal.vue'
import snakecaseKeys from 'snakecase-keys'
import { useForm } from '@inertiajs/vue3'
import { useModals } from '@/shared/composables/useModals.js'
import { notify } from '@kyvg/vue3-notification'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  applyPath: {
    type: String,
    required: true,
  },
})

const { closeModal } = useModals()

const form = useForm({
  groupMembers: {
    message: '',
  },
})
const options = [
  { label: 'I live in this city', value: 'I live in this city' },
  {
    label: 'I am visiting this city',
    value: 'I am visiting this city',
  },
]

const sendRequestInvite = () => {
  form.transform(snakecaseKeys).post(props.applyPath, {
    preserveScroll: true,
    onSuccess: () => {
      closeModal(props.name)
      notify({
        type: 'success',
        text: 'Your request has been sent, please wait for approval.',
      })
    },
  })
}
</script>
